export default {
  Sundry: 1,
  PaymentEntry: 2,
  AdvancePayment: 3,
  ReturnParts: 4,
  OrderReceipt: 5,
  DealerCredit: 6,
  FactorInvoice: 7
}
